/**
 * storageQuotaError.ts — Error tipado para fallos de escritura por cuota llena.
 *
 * QUÉ HACE:
 *  - Define `StorageQuotaError`, el error que el embudo de persistencia lanza
 *    cuando una escritura NO se puede guardar porque el almacenamiento local
 *    está lleno (QuotaExceededError agotado tras reintentos internos).
 *  - Permite que cualquier flujo (venta, crédito, inventario, personal…) detecte
 *    el caso con `isStorageQuotaError(e)` y muestre al usuario un aviso honesto
 *    en lugar de celebrar una operación que nunca se persistió.
 *
 * QUÉ EXPORTA: StorageQuotaError (clase), isStorageQuotaError (guard tipado).
 *
 * QUÉ NO DEBE HACER:
 *  - No contener lógica de negocio ni de recuperación de cuota.
 *  - No importar React, componentes ni helpers de storage.
 */
export class StorageQuotaError extends Error {
  /** Clave que no pudo persistirse. */
  readonly key: string;

  constructor(key: string) {
    super(
      "Memoria local llena: la operación NO se guardó. " +
        "Descarga un respaldo y libera espacio en Ajustes → Almacenamiento.",
    );
    this.name = "StorageQuotaError";
    this.key = key;
  }
}

/** Guard tipado: true si el error corresponde a cuota llena. */
export function isStorageQuotaError(e: unknown): e is StorageQuotaError {
  return e instanceof StorageQuotaError;
}
